import { Component, OnDestroy, OnInit, Input, Output,EventEmitter,SimpleChanges } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { HaloModalSize, HaloModalService } from 'src/app/core/halo-modal/halo-modal';
import { FacilityService } from 'src/app/core/services/facility.service';
import { MultiConsoleModel } from '../services/multi-console.model';
import { MultiFacilityModel } from '../services/multi-facility.model';
import { MultiFacilityService } from '../services/multi-facility.service';
@Component({
  selector: 'app-multiconsole-selector',
  templateUrl: './multiconsole-selector.component.html',
  styleUrls: ['./multiconsole-selector.component.scss'],
})
export class MultiConsoleSelectorComponent implements OnInit, OnDestroy {
  @Input() multiConsoles = [];
  @Output() selectedConsoleChanged = new EventEmitter<any>();

  checkedAll: boolean = false;
  selectedCount:number;
  consolesAllCount:number;
  constructor(
  ){}

  ngOnInit(): void {
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes && changes.multiConsoles && changes.multiConsoles.currentValue && changes.multiConsoles.currentValue !== changes.multiConsoles.previousValue){
      this.multiConsoles = changes.multiConsoles.currentValue;
      this.consolesAllCount = this.multiConsoles.length;
      let selectedConsoles = this.getSelectedConsole(changes.multiConsoles.currentValue);
      this.selectedCount = selectedConsoles.length;
      this.checkedAll =  this.consolesAllCount === this.selectedCount;  
      this.selectedConsoleChanged.emit(selectedConsoles);
    }
  }

  onSelectAll() {
    this.checkedAll = !this.checkedAll;
    this.updateSelectedConsole(this.checkedAll);
    this.selectedCount = this.checkedAll ? this.consolesAllCount : 0;
    this.selectedConsoleChanged.emit(this.getSelectedConsole(this.multiConsoles));
  }

  updateSelectedConsole(checkedAll:boolean){
    this.multiConsoles.forEach((val:any) => {
      if(Number(val.compatibleVideoCounts)>0){
        val.selected = checkedAll;
      }
    })
  }

  onSelect(console:any) {
    if (console) {
      console.selected = !console.selected;
      let selectedConsoles = this.getSelectedConsole(this.multiConsoles);
      this.selectedCount = selectedConsoles.length;
      this.checkedAll = this.consolesAllCount === this.selectedCount;  
      this.selectedConsoleChanged.emit(selectedConsoles);
    }
  }

  getSelectedConsole(consoles: MultiConsoleModel[]) {
    let consIds: any[] = [];
    consoles?.forEach(console => {
      if (console.selected) {
        consIds.push(console);
      }
    });
    return consIds;
  }


  ngOnDestroy(): void {
  }

}

